import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './../api/api.service';
import { IAddressgReturned, IAddressInput } from './../../models/addressInput.interface';
import { add } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AddressStandardizeService {

  constructor(private http: ApiService) { }

  public verifyaddress(address: IAddressInput): Observable<IAddressgReturned> {
    return this.http.get(`/AddressStandardize/verify?addressLine1=${encodeURIComponent(address.addressLine1)}&addressLine2=${encodeURIComponent(address.addressLine2)}&city=${encodeURIComponent(address.city)}&state=${encodeURIComponent(address.state)}&Zipcode=${encodeURIComponent(address.zipCode)}`)
    .pipe(map(res => res as IAddressgReturned));
  }
}
